function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{opacity:0.77;}\r\n\t.st1{opacity:0.85;fill:#95D2EE;enable-background:new    ;}\r\n\t.st2{display:none;fill:#FDCB08;}\r\n\t.st3{fill:#1B3156;}\r\n\t.st4{fill:#9AC3D9;}\r\n\t.st5{fill:#0C162B;}\r\n\t.st6{fill:#BFD6E4;}\r\n\t.st7{fill:#1C3156;}\r\n\t.st8{fill:#FFFFFF;}\r\n\t.st9{fill:#111F34;}\r\n\t.st10{fill:#1B293F;}\r\n\t.st11{fill:#FAC2AD;}\r\n\t.st12{fill:#978E84;}\r\n\t.st13{fill:#E5E8EC;}\r\n\t.st14{fill:#F3F7F9;}\r\n\t.st15{fill:#0E172B;}\r\n\t.st16{fill:#E08026;}\r\n\t.st17{display:none;fill:#636464;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_1_",
  d: "M238.2,127.3c58.9-28.4,37.6-90.8,118.7-80.5c81,10.4,84.9,11.4,166.4,5.1 C644.5,42.5,719,126,648.2,241.3c-15.7,25.6-18.7,51.6-13.4,73.1H224.1C195.1,285.2,113.4,187.6,238.2,127.3z",
  vectorEffect: "non-scaling-stroke"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_00000000202926600410889890000018060723658014146751_",
  d: "M491.4,133.3C435.6,105.8,424.1,33.1,380,27 c-81.9-11.2-81.5,39.5-158.7,33.3C106.5,51.2,36,132,103,243.7c14.9,24.8,17.7,49.9,12.7,70.8h388.9 C532.1,286.1,609.6,191.7,491.4,133.3z",
  vectorEffect: "non-scaling-stroke"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M394.9,338.6c297,4.7,250.1-19.3,241.1-23.4l-542.3-0.3c-8.3,8.3-171.5,31.4-42.3,43.8 c108.1,10.4,43,44.8,158,68.9c119.7,25.1,163.6-4.7,159-25.6c-2.8-12.8-24.2-18.1-33.7-20.1C150.6,342.5,300,337.1,394.9,338.6z",
  vectorEffect: "non-scaling-stroke"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -38.1655 414.1419)",
  className: "st2",
  cx: 224.3,
  cy: 229.5,
  rx: 37.5,
  ry: 37.5,
  vectorEffect: "non-scaling-stroke"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M564.4,404.3c1.3-39.7,1-74.2,1.1-113.9c0.1-77.1-45.2-116.2-69.5-141.6l15.1-8.9 c32.4,18.4,50.7,40.3,64.9,66.6s19.5,58,19.8,85.3c0.4,36.7,3.2,66.9-3.9,103.1c-1,4.9,9.6,10.2,3.1,13.1s-31.4,0.7-31.1-4.2",
  vectorEffect: "non-scaling-stroke"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M635.1,188.2l-22.2-5.3l-5.1-8.8c0,0,18.8,1.8,22.2,0s-17.1-15.9-17.1-15.9l-30.8-26.4 c-3.3-1.5-6.7-2.7-10.3-3.5c-6.8-1.8-25.7,0-25.7,0l10.3-8.8h-20.3l-5.7-1.2c0,0,22.7-4.9,25.1-4.9s13.1,11.1,13.1,11.1l-9.6-22.2 l12,11.1l51.4-16l-12-11.1c2.3-0.8,4.7-1.2,7.2-1.3c3.6,0,17.9,7.4,19.1,7.4s-7.2-8.6-11.9-11.1s-8.4-4.9-17.9-8.6s-21.5-2.5-37,0 c-10.4,1.7-21.3,7.7-33.1,15.2L524,84.3v-5.7l16.5,4.2l15.1-15.6l-13.7-2.8l1.4-7.1l26.1,7.1l5.5-4.2l-8.2-4.2c0,0-8.2-1.4-13.7-2.8 s-24.7,0-24.7,0c3-1.9,6.2-3.3,9.6-4.2c5.5-1.4,20.6,0,20.6,0l22-32.5H575l-20.6,2.8c2.9-2.2,5.6-4.6,8.2-7.1 c2.7-2.8,27.5-1.4,27.5-1.4l11-4.2c-2.6-1.7-5.3-3.2-8.2-4.2c-4.1-1.4-31.6-1.4-42.6,0s-30.4,12.6-40,25.4s-11,35.4-15.1,59.4 c-2.3,13.1-3.3,26.5-2.8,39.8c-5.2-13.8-34.8-89.4-61.9-101.2c-29.8-12.9-61.1-8.1-61.1-8.1l-15.7,9.7c0,0,6.3,6.5,14.1,4.9 s17.2-3.2,18.8-3.2s9.4,3.2,9.4,3.2s-14.1,3.2-15.7,4.8s-1.6,6.5-1.6,6.5l29.8,22.6c0,0,18.8-4.8,21.9-3.2c3.1,1.6,1.5,3.2,1.5,3.2 s-11,0-15.7,1.6s-11,11.3-11,11.3L410,84l17.2-11.3l3.1,3.2l-6.2,8.1l15.7,11.3l9.4-6.5l1.6,4.8l-4.7,8.1l36,21l-2.7,1.8 c-28.1-11.1-94.7-35-120.9-23.2c-33.6,15.2-53.7,45.7-53.7,45.7l-4,21c0,0,10.2-0.2,14.9-8.2s10.6-17.3,11.8-18.6s9.9-5.5,9.9-5.5 s-8.2,14.6-8,17.2s4.1,6.4,4.1,6.4l41.6-7.5c0,0,10.5-19.9,14.2-21.3s3.9,1.2,3.9,1.2s-8.4,9.4-10.7,14.6s0.9,18.3,0.9,18.3l7.6-0.2 l3.9-23.6l5.1-0.1l1.9,11.7l21.4-4.4l1.9-13.1l5.2,2.5l3.1,10.4l45.1-14.1l-0.9,6.5c-3.2,1.4-6.5,3-9.7,4.8 c-19.1,10.6-43.3,23.1-53.3,44.6S402.3,217,403.8,228s8.5,45.5,8.5,45.5l30.3,23.4c8.5,6.5,20.9,10.3,20.9,10.3l3-25l-13.9-14.6 l10.9,0.6l-0.9-29.9l0.6-11.2c0,0-8.2-4.4-10.3-11.9s1.5-4.7,1.5-4.7s9.4,13.1,13.9,14.6c2.5,0.8,4.9,1.9,7,3.4l5.1-17.5l-13-23.7 l-1.2-16.5l1.2-6.9c0,0,6.4,14.7,8.2,20c1.7,4.3,3.7,8.5,6,12.5c0,0-3.3-16.2-3.3-24c-0.1-4.2,0.4-8.4,1.5-12.5l8.8,16.5l15.7-19 l-1.2-8.8l1.9-1.2l5.4,10.4l20.5,5.3l-1.7-17.6l13.7,24.7l-1.7-19.4l12,21.1l25.7,26.4l6.8,17.6l10.3-10.6c0,0,18.8,24.7,25.7,30 s18.8,15.9,18.8,15.9v-15.9L635.1,188.2z",
  vectorEffect: "non-scaling-stroke"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M562.3,358.8c2.1-2,5.1-1.9,7.7-1.2c3,0.9,5.9,1.9,8.8,3.1c3.9,1.5,9.6,3.3,12.5-0.9H590c1.4,2.5,4.2,3.9,7,3.5 c3.4-0.3,6.2-2.6,8.8-4.7c0.8-0.6-0.3-1.7-1.1-1.1c-2.2,1.8-4.5,3.7-7.3,4.2c-2.4,0.6-4.9-0.5-6.2-2.7c-0.2-0.4-0.7-0.5-1.1-0.2 c-0.1,0.1-0.2,0.1-0.2,0.2c-1.4,2.1-4.2,2.1-6.4,1.6c-2.9-0.8-5.8-1.8-8.5-3c-4.3-1.6-10-3.7-13.8,0.1 C560.5,358.4,561.6,359.4,562.3,358.8L562.3,358.8z",
  vectorEffect: "non-scaling-stroke"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M563.2,318.1c7.5,0.6,15,1.3,22.5,1.7c4.7,0.2,10.5-0.3,12.9-4.9c0.5-0.9-0.8-1.6-1.3-0.8 c-2.4,4.5-8.5,4.4-12.9,4.1c-7.1-0.5-14.2-1.1-21.2-1.6C562.2,316.5,562.2,318,563.2,318.1z",
  vectorEffect: "non-scaling-stroke"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M562.7,280.9c-0.8-2.4,2.2-4.1,4.2-3.5c2.4,0.7,4,3.1,5.4,5c0.2,0.4,0.7,0.5,1,0.2c0.2-0.1,0.3-0.2,0.3-0.4 c1.3-3.6,6.1-4,9.3-4.6l15-2.5c1-0.1,0.5-1.6-0.4-1.4c-5.6,0.9-11.2,1.8-16.9,2.8c-3.4,0.6-7.2,1.7-8.5,5.3l1.4-0.2 c-1.8-2.6-4.2-6.1-7.7-5.9c-2.8,0.1-5.5,2.7-4.6,5.6C561.5,282.2,563,281.8,562.7,280.9L562.7,280.9z",
  vectorEffect: "non-scaling-stroke"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M555.5,235.1c-0.7-1.8-0.2-3.8,1.3-5l-0.9,0.1l2.1,1.6c0.5,0.4,0.9,0.8,1.5,0.8c0.8-0.2,1.5-0.4,2.2-0.8 c0.8-0.3,1.6-0.6,2.4-0.9c3.1-1.2,6.1-2.4,9.1-3.8c5.5-2.6,10.9-5.6,15-10.1c0.7-0.7-0.4-1.8-1.1-1.1c-3.8,4.2-8.8,7-13.9,9.4 c-2.8,1.3-5.6,2.6-8.5,3.7c-1.5,0.6-2.9,1.1-4.4,1.6c-0.8,0.3-1,0.3-1.7-0.2l-2.1-1.6c-0.3-0.2-0.7-0.1-0.9,0.1 c-1.9,1.6-2.5,4.2-1.6,6.5C554.4,236.5,555.9,236.1,555.5,235.1L555.5,235.1z",
  vectorEffect: "non-scaling-stroke"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M531.5,191.1c-0.9-1.7-0.3-3.9,1.4-4.8c0.4-0.2,0.9-0.4,1.4-0.4c1.7-0.1,3.4,1.6,5.1,0.5c0.6-0.4,0.9-1,0.9-1.6 c0-0.7-0.8-2.4,0.2-2.6c0.4-0.1,1.3,0.4,1.7,0.6l1.8,0.6l3.6,1.2c0.4,0.1,0.8-0.1,1-0.5c0-0.1,0-0.2,0-0.3l-0.3-2.5 c-0.2-0.8-0.3-1.7-0.3-2.5c0.4-1.1,3.9-0.6,4.8-0.4s2.2,0.8,2.9-0.1s0.5-2.6,0.6-3.6s-1.4-0.9-1.5,0c0,0.8,0,1.6-0.2,2.4 c0.1,0.3,0,0.3-0.3,0.2l-0.4-0.1c-0.4-0.1-0.8-0.2-1.3-0.2c-1.4-0.2-2.8-0.2-4.1,0.1c-1.2,0.2-2,0.6-1.9,1.9c0,1.7,0.3,3.4,0.5,5 l1-0.7l-4.5-1.6c-1-0.4-2.6-1.2-3.7-0.9c-0.7,0.3-1.2,1-1.2,1.8c0,0.5,0,1,0.2,1.4c0.3,1.4-0.7,1.5-1.7,1.2c-2.1-0.8-4.3-0.9-6,0.8 c-1.6,1.6-1.9,4.1-0.8,6.1c0.4,0.9,1.7,0.1,1.3-0.8L531.5,191.1z",
  vectorEffect: "non-scaling-stroke"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M195.1,296.9c-0.4-0.5-1-0.8-1.7-0.8v-0.4l-0.4-0.8h-0.4c-0.3,0-0.6,0.2-0.9,0.4l-0.8-5.1l2.1-0.4v-0.4h-2.5 V289l0.4-0.4v-0.8l-0.9-2.1l-2.1,1.7v2.1h-1.3l0.9,1.3v5.5l-1.7-1.7h-3.4l1.3-3h0.8l-0.8-0.9v-0.4h-5.1V289l0.8-0.4h-0.8l0.4-2.1 l0.4-0.4H179l0.4-4.2h1.7v-1.3h0.4l-0.2-0.2h-0.8l-0.2,0.2h0.4v0.8H179V280h-0.4v1.7h-0.9v-0.4l-0.2-0.2l0.4-0.4h-1.3l0.2,0.6h0.4 v0.9h1.3l-0.4,3.8h-3v0.4h3l-0.4,1.7h-4.3l0.4,0.9v1.3H170l-1.2,1.3h0.8l0.9,2.1h-1.3l0.9,1.3h1.7l-1.3,6.7l-3.5,2h-2.8v-0.2 l-0.8-0.4v-1.7h0.4v-0.9l-0.4-0.4v-0.4h-7.2v-1.3l3.8-1.7v-0.9h-3.8l0.4-1.3h-1.3l0.4,1.3l-9.7-0.4l-3,1.7l-0.4,0.9v1.7h-15.2v0.4 h-0.8v3h-2.1c-0.4,0,0-0.9,0-0.9l-11-0.4c0,0-1.5,0.8-2.8,1.6l-2.8-1L96.3,302l0,0l-1.3-2.5l0.8-3.8l0.8-0.8h-0.8l0.4-5.1l1.3-0.4 h-1.7v0.4l-1.3,5.1h-2.1l2.1,0.8l-1.7,5.9v0.4l-10.3-0.2l2.7,3.4h26.5l-0.2,0.6l0.3-0.6h38.5l6.8,0.2v-0.2h0.6l0.2,0.6l6.3-0.4v-0.2 h32.3v-2.5h-1.1v-1.9h0.4l0.8-0.8v-0.4l0.4-0.4L195.1,296.9z",
  vectorEffect: "non-scaling-stroke"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M90,311.1h106.6v1.3l-0.4,1.7l-0.4,0.4v3.8h-2.5l-1.7-1.3h-0.8c-1,1.1-2.4,1.7-3.8,1.7L96.1,319 c0,0-4.7-6.3-5.1-6.7C90.9,312.3,90.5,311.8,90,311.1z",
  vectorEffect: "non-scaling-stroke"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M85.2,305.2h111.4v5.9H90C88.8,309.6,86.8,307.2,85.2,305.2z",
  vectorEffect: "non-scaling-stroke"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M185.4,323.9c0.9-0.6,2-0.9,3.1-0.8c1,0.1,2.1,0.4,2.9,1c0.9,0.5,1.7,1.2,2.3,2.1s1,1.9,1,3 c-0.3,2-1.2,3.9-2.6,5.4c-1.3,1.5-2.8,2.8-4.1,4.2c-1.4,1.3-2.4,2.9-3,4.6c-0.3,0.9-0.4,1.8-0.3,2.7c0.1,0.9,0.5,1.7,1.1,2.3 c0.6,0.6,1.4,1.1,2.3,1.4c0.9,0.3,1.8,0.5,2.7,0.6c1.9,0.2,3.8,0.2,5.8,0.4c2,0.1,4,0.9,5.5,2.2c0.7,0.8,1.2,1.7,1.4,2.7 s0.2,2,0.2,3c0,1.9-0.2,3.9,0.4,5.6c0.8,1.7,2.1,3.1,3.9,3.8c3.4,1.6,7.4,2,11.2,2s7.8-0.2,11.6,0.5c1.9,0.3,3.8,1,5.5,2.1 c1.6,1.1,3,2.6,4,4.2c2.1,3.3,3.3,7.1,6.2,9.7c1.4,1.3,3.1,2.2,5,2.6c1.9,0.5,3.8,0.7,5.7,0.7c3.9,0,7.7-0.5,11.6-0.3 c1.9,0.1,3.9,0.4,5.7,0.9c1.9,0.6,3.6,1.5,5.2,2.6c3.2,2.3,5.6,5.3,8.2,8.2c2.5,3,5.5,5.4,9,7.1c1.7,0.8,3.6,1.4,5.5,1.6 s3.9,0,5.7-0.7c-1.8,0.7-3.8,0.9-5.7,0.7c-1.9-0.2-3.8-0.8-5.6-1.6c-3.5-1.7-6.6-4.1-9.1-7.1c-2.6-2.9-5-5.9-8.2-8.1 c-1.6-1.1-3.3-2-5.1-2.6c-1.8-0.5-3.8-0.8-5.7-0.9c-3.9-0.1-7.7,0.4-11.6,0.4c-2,0-3.9-0.2-5.8-0.6c-1.9-0.5-3.7-1.4-5.2-2.7 c-2.9-2.7-4.2-6.5-6.3-9.7c-1-1.6-2.3-3-3.9-4.1c-1.6-1-3.4-1.7-5.3-2c-3.8-0.7-7.7-0.4-11.5-0.4c-3.9,0.2-7.8-0.5-11.5-2 c-1.9-0.8-3.4-2.3-4.2-4.1c-0.8-1.9-0.6-4-0.5-5.9s-0.1-3.9-1.4-5.2c-1.4-1.2-3.2-1.9-5.1-2c-1.9-0.2-3.8-0.2-5.8-0.4 c-1-0.1-2-0.3-2.9-0.6c-1-0.3-1.9-0.9-2.6-1.6c-0.7-0.8-1.2-1.7-1.4-2.8c-0.1-1,0-2,0.3-3c0.7-1.9,1.8-3.6,3.2-5s2.8-2.7,4-4.1 c0.6-0.7,1.2-1.5,1.6-2.3c0.4-0.8,0.7-1.6,0.8-2.5c-0.2-1.8-1.2-3.4-2.8-4.2c-1.5-1-3.4-1.1-5-0.2c-0.2,0.2-0.5,0.2-0.7,0 s-0.2-0.5,0-0.7c0,0,0.1,0,0.1-0.1L185.4,323.9z",
  vectorEffect: "non-scaling-stroke"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M401.6,459c1.3,3.5,11.1,12.5,1.1,14.3s-28.9-2.6-28.9-2.6s-4.7-0.9-1-3.6S401.6,459,401.6,459z",
  vectorEffect: "non-scaling-stroke"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M338.9,431.3c1.3,2.7,10.3,9.1,1.9,11.3s-24.9-0.1-24.9-0.1s-4.1-0.4-1-2.8S338.9,431.3,338.9,431.3z",
  vectorEffect: "non-scaling-stroke"
});

var _ref20 = /*#__PURE__*/React.createElement("polygon", {
  className: "st5",
  points: "344.1,284.8 332.3,433.5 344.3,439.5 394.8,257 365.1,241.6 ",
  vectorEffect: "non-scaling-stroke"
});

var _ref21 = /*#__PURE__*/React.createElement("polygon", {
  className: "st10",
  points: "411.6,281.2 412.6,359.4 407.7,469.5 392.7,461.5 365.7,298.7 ",
  vectorEffect: "non-scaling-stroke"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M398.6,189.3c0,0-10.8,36.9-21,35.4c-6.1-0.9-51.9-26.2-51.9-26.2l-43.2-25.4l3.8-11.6l61.7,17.1l28.3,4.9 L398.6,189.3z",
  vectorEffect: "non-scaling-stroke"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M383.1,203.6l39.2,3.8c0,0-11.5-9.2-11.3-20.2s9.8-29.7,9.8-29.7L400.5,140c0,0-18,1-19.6,5.6 c-1,2.8,0.7,7,2.2,9.9l-5.7,8.7c-0.6,0.9-0.3,2.2,0.6,2.8l0,0l4.9,2.9l-0.9,4.6c0,0,7.7,10.3,6.8,15.1S383.1,203.6,383.1,203.6z",
  vectorEffect: "non-scaling-stroke"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M412.1,180.6c0,0,17.6,30.2,16,40s-17,74.7-42,73c-61.5-4.1-28-48-28-48l23-60l5-3l4,14L412.1,180.6z",
  vectorEffect: "non-scaling-stroke"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M379.9,151.9c0,0-2.3,4.4,2.5,7.5c2.8,1.9,6.3,2.6,9.6,1.9c0.7,3,1.1,6.1,1.1,9.2c0,4.2-0.1,6.6-3.6,6.1 s-7.4-4.1-7.4-4.1c-0.7,2.3-1,4.6-1,7c-0.1,4.4-1,12,9,12c5,0,7.8-5.4,7.7-11.3s-2.3-20.7-2.3-20.7s-0.8-4,2.5-2.8 c2.4,0.8,4.3,2.8,4.7,5.4c0.2,1.5-1.5,10.5-1.5,10.5l0.5,9c0,0,11.1-6.4,15.1-9.4c3.4-2.6,6.3-5.8,8.5-9.5c1.8-3,5.6-5.4,3.9-11.1 S379.9,151.9,379.9,151.9z",
  vectorEffect: "non-scaling-stroke"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M393.4,206.2c0,0,24.2-11.9,22.8-3.1s-9.7,97.9-34.6,95.9c-61.3-5-28.9-44-28.9-44l27.4-64.4l0.3,11.8l9.8-6.1 L393.4,206.2z",
  vectorEffect: "non-scaling-stroke"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M383.4,146.8l36.3,8.3c0,0,14-4.3,14.5-12.7c0.2-4.5-8.1-4.4-12.5-7.7c-3.5-2.6-24.6-11.6-28.7-12.4 c-6.9-1.2-8.2,2.3-8.2,2.3s-2.8,8.1-3.2,11.4C381.1,140.2,383.4,146.8,383.4,146.8z",
  vectorEffect: "non-scaling-stroke"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M380.1,139.9c0,0,1.1-1.6-2.6,0.2c-4,1.9-8.5,6.2-4.6,9.8c2.2,2.1,5.1,3.2,8.1,3.2c0,0,16.9,1.2,20.1,2.3 s30.9,3.2,29.2-2.6s-24-5.9-27.7-8s-7-15.7-17.7-16.6C379.5,127.9,380.1,139.9,380.1,139.9z",
  vectorEffect: "non-scaling-stroke"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M420.3,186.1c0,0,17.7,27.6,16,37.3s-29.2,100.1-58.6,88.5c-34.3-13.6-38.1-30.7-35.7-42.3 c1-4.8,3.1-9.2,6.1-13.1l33-72l1,4l-16,52L420.3,186.1z",
  vectorEffect: "non-scaling-stroke"
});

var _ref30 = /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 350.2,
  cy: 265.5,
  r: 3.1,
  vectorEffect: "non-scaling-stroke"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M429.2,201.3c0,0,11.3,12.1,12.2,19.3c0.8,7.2,1.8,29.7,1.8,29.7l-30.2,84.1l-11-4l12.3-72.7l1-33.7 L429.2,201.3z",
  vectorEffect: "non-scaling-stroke"
});

var _ref32 = /*#__PURE__*/React.createElement("rect", {
  x: 289.8,
  y: 80.1,
  className: "st17",
  width: 8,
  height: 189,
  vectorEffect: "non-scaling-stroke"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M399.8,330.3c-10,1.2-0.2,3.6-0.8,4.9c-3.2,7-5.5,4.7-6.3,5.8c-0.8,1.2,1.1,2.8,2.4,4.5 c1.3,1.8,3.6,2.6,5.7,2.1c6.3-1,6.3-4.1,10.9-12.8C411.6,334.9,402.7,330.8,399.8,330.3z",
  vectorEffect: "non-scaling-stroke"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M263.2,157.5c1.4-1.1,9,4.7,10.2,5.2c-0.9-1.3-9-7.8-7.7-8.7c0.6-1.4,9.3,5,10.1,5.2c-0.5-0.8-8.4-7-6.9-8.4 c1.6-1.7,8.3,5.7,8.8,5.6c1.1-0.2-4.6-5-3.7-6c1.8-0.5,7.6,4.7,8.1,5c3.2,2.5,6.5,5.9,6.6,9.4c-0.5,5.5-2.9,8.7-8.1,7.9 c-1.3-0.2-16.6-0.2-16.6-0.2c-2.4-3.6,11.1-2.2,7.6-5.5C269.3,163.9,262.2,158.3,263.2,157.5z",
  vectorEffect: "non-scaling-stroke"
});

const SvgLogoutIllustration = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shapes",
    x: "0px",
    y: "0px",
    viewBox: "0 0 677.7 477",
    style: {
      enableBackground: "new 0 0 677.7 477"
    },
    xmlSpace: "preserve",
    width: "NaN",
    height: "NaN",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000019679182872950183660000016568740677114695310_",
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    },
    vectorEffect: "non-scaling-stroke"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref4, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005980590901917400880000007738177257267476112_",
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000202926600410889890000018060723658014146751_",
    style: {
      overflow: "visible"
    },
    vectorEffect: "non-scaling-stroke"
  }))))), _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoutIllustration, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logout_illustration.5985ee3d.svg";
export { ForwardRef as ReactComponent };